import React from "react";
import themePropTypes from "../theme-prop-types";

const ExpansionMessage = ({
  expanded,
  title,
  updatedAt,
  toggleExpansion,
  shortDescription,
  body
}) => (
  /* eslint-disable jsx-a11y/click-events-have-key-events */
  /* eslint-disable jsx-a11y/no-static-element-interactions */
  <div className={`expansion-message-web-sdk ${expanded && "expanded"}`}>
    <div className='header' onClick={toggleExpansion}>
      <div className='title'>{title}</div>
      <div className='updated-at'>{updatedAt}</div>
      <div
        className='description'
        dangerouslySetInnerHTML={{ __html: shortDescription }}
      ></div>
    </div>
    <div className='body'>{body}</div>
  </div>
);
ExpansionMessage.propTypes = themePropTypes.expansionPanel;

export default ExpansionMessage;
